import {
  Button,
  InfoModalStyle,
  Close
} from "@/imports-files/components/common-modal/common-modal";
import parse from "html-react-parser";

const InfoModal = (props) => {
  const { content, className } = props;
  const points = [
    "Search candidates via name, email, skills, location, or any other keyword from their CV.",
    "Candidate search supports boolean operators (AND, OR, NOT) and parentheses () for grouping.",
    "Search results only include candidates with CV except for when search criteria is a name or email.",
    "We use auto-stemming on words longer than 6 characters i.e., any word longer than 6 characters will be searched as: For example you are searching for Project Manager, the search will give results for Projec* Manage*",
  ];

  return (
    <div className={`${InfoModalStyle.ModalOverlay}`}>
      <div className={`${InfoModalStyle.Modal} ${props?.largeWidth && InfoModalStyle.ModalLarge} ${props?.mdWidth && InfoModalStyle.ModalMd} ${props?.hiredModal && InfoModalStyle.HiredPoup}`}>
        <div className={`${InfoModalStyle.Modal__Container}`}>
         {props.noCloseIcon ? null : (<div
            className={`${InfoModalStyle.Modal__Container__CloseSection}`}
            onClick={() => {
              props?.closeModal();
            }}
          >
            <Close/>
            CLOSE
          </div>)}
          <div className={`${InfoModalStyle.Modal__Container__ContentSection} ${props.className}`}>
            {props?.heading && (
              <h1
                className={`${InfoModalStyle.Modal__Container__ContentSection__Heading} ${props.className}`}
              >
                {props?.heading}
              </h1>
            )}
            {props?.case == "search" && (
              <ol
                className={`${InfoModalStyle.Modal__Container__ContentSection__ListContainer}`}
              >
                {points.map((point, index) => {
                  return (
                    <li
                      key={index}
                      className={
                        InfoModalStyle.Modal__Container__ContentSection__ListContainer__Points
                      }
                    >
                      {point}
                    </li>
                  );
                })}
              </ol>
            )}
            {props?.case == "privacyPolicy" && (
              <div
                className={
                  InfoModalStyle.Modal__Container__ContentSection__Description
                }
              >
                {parse(content)}
              </div>
            )}
            {props?.innerContent}
          </div>
          {props?.texts?.button1_text && (
            <div className={InfoModalStyle.Modal__Container__ButtonSection}>
              <Button
                buttonstyle={InfoModalStyle.primarybtn}
                onClick={() => {
                  props.closeModal();
                }}
              >
                {props?.texts?.button1_text || "Cancel"}
              </Button>
              {props?.texts?.button2_text && (
                <Button
                  buttonstyle={InfoModalStyle.secondarybtn}
                  onClick={() => {
                    props.btnAction();
                  }}
                >
                  {props?.texts?.button2_text || "Delete"}
                </Button>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
export default InfoModal;
